import React from 'react';
import Sidebar from '../../components/Super Admin/SideBar/Sidebar';
import Tabs from '../../components/Super Admin/TopBar/TopbarPayments';
import Refund from '../../components/Super Admin/Payment/Refund';
import '../../css/RefundPage.css';

const RefundPage: React.FC = () => {
  return (
    <>
        <Tabs activeTab="refund" />
        <Refund />
    </>
  );
};

export default RefundPage;
